import { render, staticRenderFns } from "./BLSHJ02Component.vue?vue&type=template&id=cf10b08a&scoped=true&"
import script from "./BLSHJ02Component.vue?vue&type=script&lang=js&"
export * from "./BLSHJ02Component.vue?vue&type=script&lang=js&"
import style0 from "./BLSHJ02Component.vue?vue&type=style&index=0&id=cf10b08a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf10b08a",
  null
  
)

export default component.exports